import cn from 'classnames';
import React, {FC, RefObject, CSSProperties} from 'react';

import {useHorizontalScroll} from '../hooks/use-horizontal-scroll';
import styles from './horizontal-scroll.module.less';

interface IHorizontalScrollProps {
  containerRef: RefObject<HTMLElement>;
  scrollableSelector?: string;
  enabled?: boolean;
  className?: string;
  style?: CSSProperties;
}

export const HorizontalScroll: FC<IHorizontalScrollProps> = ({
    containerRef,
    scrollableSelector,
    enabled = true,
    className,
    style,
}: IHorizontalScrollProps) => {
    const {
        scrollState,
        handleMouseDown,
        progressRef,
        thumbRef,
        scrollbarRef,
        isThresholdReached,
    } = useHorizontalScroll({
        containerRef,
        scrollableSelector,
        enabled,
    });

    if (!enabled || !scrollState.isScrollable || !isThresholdReached) {
        return null;
    }

    return (
        <div
            ref={scrollbarRef}
            className={cn(styles.horizontalScroll, className)}
            style={{...style}}
        >
            <div className={styles.container}>
                <div
                    className={styles.track}
                    onMouseDown={handleMouseDown}
                >
                    <div
                        ref={progressRef}
                        className={styles.progress}
                    />
                    <div
                        ref={thumbRef}
                        className={styles.thumb}
                    />
                </div>
            </div>
        </div>
    );
};
